import request from '@/utils/request/bus'

/**
 * ecenter 菜单列表（去系统化：默认 systemSign=gemini3）
 * 接口：/bus/ecenter/system/menu/list?systemSign=gemini3
 */
export function listMenuEcenter(params = {}) {
  const systemSign = params.systemSign ?? 'gemini3'
  return request({
    // request/bus 的 baseURL 是 /bus/，这里不要再带前导 '/'
    url: 'ecenter/system/menu/list',
    method: 'get',
    params: {
      ...params,
      systemSign,
    },
  })
}

/** 菜单下拉树（角色授权树，对齐 ecenter-ui：/menu/treeselect） */
export function menuTreeselectEcenter(params = {}) {
  const systemSign = params.systemSign ?? 'gemini3'
  return request({
    url: 'ecenter/system/menu/treeselect',
    method: 'get',
    params: {
      ...params,
      systemSign,
    },
  })
}

/**
 * 根据 ID 获取菜单详情
 */
export function getMenuEcenter(menuId) {
  return request({
    url: `ecenter/system/menu/${menuId}`,
    method: 'get',
  })
}

/**
 * 新增菜单
 */
export function addMenuEcenter(data) {
  return request({
    url: 'ecenter/system/menu',
    method: 'post',
    data,
  })
}

/**
 * 修改菜单
 */
export function updateMenuEcenter(data) {
  return request({
    url: 'ecenter/system/menu',
    method: 'put',
    data,
  })
}

/**
 * 删除菜单
 */
export function delMenuEcenter(menuId) {
  return request({
    url: `ecenter/system/menu/${menuId}`,
    method: 'delete',
  })
}

// ---------- 角色（ecenter-ui：`/system/role/*` → `/bus/ecenter/system/role/*`）----------

const roleCtxDefaults = () => ({
  systemSign: 'gemini3',
  /** ecenter 旧参数：若无 channel 概念可忽略，由网关兼容 */
  channelId: 1,
})

function withRoleCtx(params = {}) {
  const d = roleCtxDefaults()
  return {
    ...d,
    ...params,
  }
}

/** 角色分页列表 */
export function listRoleEcenter(params = {}) {
  return request({
    url: 'ecenter/system/role/list',
    method: 'get',
    params: withRoleCtx(params),
  })
}

/** 菜单权限树（授权勾选用） */
export function roleMenusTreeselectEcenter(params = {}) {
  return request({
    url: 'ecenter/system/role/menus',
    method: 'get',
    params: withRoleCtx(params),
  })
}

/** 角色详情（含已勾选菜单 keys） */
export function getRoleDetailEcenter(roleId) {
  return request({
    url: 'ecenter/system/role/detail',
    method: 'get',
    params: { roleId },
  })
}

/** 角色菜单勾选详情（旧系统编辑角色使用） */
export function getRoleMenuTreeselectEcenter(roleId, params = {}) {
  return request({
    url: `ecenter/system/menu/roleMenuTreeselect/${roleId}`,
    method: 'get',
    params: withRoleCtx(params),
  })
}

export function addRoleEcenter(data) {
  return request({
    url: 'ecenter/system/role',
    method: 'post',
    data: {
      ...roleCtxDefaults(),
      ...data,
    },
  })
}

export function updateRoleEcenter(data) {
  return request({
    url: 'ecenter/system/role',
    method: 'put',
    data: {
      ...roleCtxDefaults(),
      ...data,
    },
  })
}

/** 删除角色（旧系统：DELETE /role/{roleId}） */
export function delRoleEcenter(roleId) {
  return request({
    url: `ecenter/system/role/${roleId}`,
    method: 'delete',
  })
}

/** 状态切换（若网关未实现会 404，可再改为「拉详情后整单更新」） */
export function changeRoleStatusEcenter(data) {
  return request({
    url: 'ecenter/system/role/changeStatus',
    method: 'put',
    data,
  })
}

/** 角色数据权限树（旧系统：roleDeptTreeselect） */
export function getRoleDataRulesEcenter(roleId, params = {}) {
  return request({
    url: `ecenter/system/dept/roleDeptTreeselect/${roleId}`,
    method: 'get',
    params: withRoleCtx(params),
  })
}

/** 保存角色数据权限（旧系统：dataScope） */
export function setRoleDataRulesEcenter(data) {
  return request({
    url: 'ecenter/system/role/dataScope',
    method: 'put',
    data,
  })
}

/** 角色已分配用户 */
export function listRoleUsersEcenter(params) {
  return request({
    url: 'ecenter/system/role/authUser/allocatedList',
    method: 'get',
    params: withRoleCtx(params),
  })
}

/** 未选入该角色的用户（分配用） */
export function listRoleUserNoselectEcenter(params) {
  return request({
    url: 'ecenter/system/role/authUser/unallocatedList',
    method: 'get',
    params: withRoleCtx(params),
  })
}

export function roleAuthUserCancelAllEcenter(data) {
  return request({
    url: 'ecenter/system/role/authUser/cancel',
    method: 'put',
    data,
  })
}

export function roleAuthUserSelectAllEcenter(data) {
  return request({
    url: 'ecenter/system/role/authUser/selectAll',
    method: 'put',
    data,
  })
}

// ---------- 组织（部门） ----------
export function listDeptEcenter(params = {}) {
  return request({
    url: 'ecenter/system/dept/list',
    method: 'get',
    params,
  })
}

export function getDeptEcenter(deptId) {
  return request({
    url: `ecenter/system/dept/${deptId}`,
    method: 'get',
  })
}

export function addDeptEcenter(data) {
  return request({
    url: 'ecenter/system/dept',
    method: 'post',
    data,
  })
}

export function updateDeptEcenter(data) {
  return request({
    url: 'ecenter/system/dept',
    method: 'put',
    data,
  })
}

export function delDeptEcenter(deptId) {
  return request({
    url: `ecenter/system/dept/${deptId}`,
    method: 'delete',
  })
}

export function treeselectDeptEcenter() {
  return request({
    url: 'ecenter/system/dept/treeselect',
    method: 'get',
  })
}

export function deptStationEcenter(deptId) {
  return request({
    url: `ecenter/system/dept/selectStation/${deptId}`,
    method: 'get',
  })
}

export function relationStationEcenter(deptId, stationIds) {
  return request({
    url: 'ecenter/system/dept/addStation',
    method: 'post',
    data: {
      deptId,
      stationIds,
    },
  })
}

export function listStationEcenter(params = {}) {
  return request({
    url: 'device/station/list',
    method: 'get',
    params,
  })
}

